module.exports = __webpack_public_path__ + "static/media/RI-D3-8.5-053.dbdba9f2.webp";